<template>
  <QuestionBody :qsNumber="qsNumber" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-10",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 10,
      // nextPage: '/questionnaire/section1/11',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Pregnancy.png'),
        mainTitle: 'Which stage of the following are you currently in?',
        btn: [
          [
            {
              text: 'Early pregnancy(within 12 weeks)',
              link: '/questionnaire/section1/11'
            }
          ],[
            {
              text: 'Pregnant metaphase(13-28 weeks)',
              link: '/questionnaire/section1/12'
            }
          ],[
            {
              text: 'Late pregnancy(29-40 weeks)',
              link: '/questionnaire/section1/13'
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
